<template>
  <div style="text-align: center; background: transparent; padding: 6px; min-width: 100%">
    <!-- isInMainArray {{ isInMainArray ? "TRUE" : "FALSE" }} -->

    <!-- <div>TEST {{ record  }}</div> -->
    <div :style="{ background: isInMainArray ? '#21980c80' : 'transparent' }">
      <!-- {{ isInMainArray }} -->

      <!-- <span>CARDBODY</span> -->
      <h4 v-if="record.personID">{{ record.personID }}</h4>
      <h4 v-if="record.personId">{{ record.personId }}</h4>
      <font-awesome-icon size="4x" icon="user" />
      <h5 v-if="record.gender">{{ record.gender }} - {{ record.dateOfBirth }}</h5>
      <br />
      <h4>{{ record.lastName }} {{ record.firstName }}</h4>
    </div>
  </div>
  <!-- {{ record }} -->

  <!-- <h5 v-b-toggle.my-collapse1>Details</h5>
  <b-collapse id="my-collapse1">
    v-b-toggle.my-collapse1

    {{ record }}
  </b-collapse> -->
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
// * STOREs
import { useUsersPatientsStore } from "@/stores/usersPatientStore";
const usersPatStore = useUsersPatientsStore();
// & PROPS
const props = defineProps({
  record: {
    Type: Object,
    Default: () => {},
  },
});

const AreIdsShown = ref(true);

// Computed property to check if personID exists in store array
const isInMainArray = computed(() => {
  const patientId = Number(props.record?.personId);
  if (patientId && usersPatStore.patientIDStartList.includes(patientId)) {
    // console.log(`usersPatStore   Patient ID ${patientId} FOUND !!!!!!!!!!!! `);
    return true;
  }
  return false;
});

function getFullName(data) {
  if (!data) return "";
  const { lastName = "", middleName = "", firstName = "" } = data;
  return `${lastName}, ${middleName} ${firstName}`;
}

onMounted(() => {
  // console.log("onMounted() :    Widget Primary   Card BODY >>>>");
});
</script>

<style>
.task__header {
  padding: 18px 30px;
  font-size: 16px;
  font-weight: 700;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  background: #21980c;
}
</style>
